import { useState } from 'react'

import LogoIcon from '@/assets/logo-icon.svg?react'
import { CONTAINER_MAX_WIDTH, GENERAL_CONTACT_URL, HELP_CENTER_URL } from '@/config/constants'
import useFeatureFlags from '@/hooks/useFeatureFlags'
import { Box, Button, Flex, HStack, Link, Spacer, Text } from '@chakra-ui/react'
import { useTranslation } from '@infraloop/i18n'

import useUser from '../hooks/useUser'
import { hasDeprecatedSubscription } from '../utils'
import TermsOfServiceModal from './TermsOfServiceModal'

const Footer = () => {
  // Hooks
  const { t } = useTranslation()
  const { user } = useUser()
  const { featureFlags } = useFeatureFlags()

  // States
  const [isTosOpen, setIsTosOpen] = useState(false)

  // Derived state — mirror the legacy footer: the ToS entry only exists for users on
  // self-managed subscriptions (the deprecated subscription types predate the ToS flow).
  const isTosAvailable = Boolean(
    user && featureFlags?.selfManagedSubscriptions.enabled && !hasDeprecatedSubscription(user),
  )

  return (
    <Box as="footer" borderTop="1px solid" borderColor="gray.200" bg="white">
      <Flex maxW={CONTAINER_MAX_WIDTH} mx="auto" px="28px" py="22px" align="center" gap="13px" flexWrap="wrap">
        <Box asChild>
          <LogoIcon width="30px" height="30px" title="Hatsuly" />
        </Box>
        <Text fontSize="13px" color="gray.500">
          {t('hatsuly.footer.copyright')}
        </Text>
        <Spacer />
        <HStack gap="28px">
          <Link
            href={HELP_CENTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            fontSize="13px"
            color="gray.500"
            textDecoration="none"
            _hover={{ color: 'gray.700' }}
            data-testid="footer-manual"
          >
            {t('hatsuly.footer.manual')}
          </Link>
          {isTosAvailable && (
            <Button
              variant="plain"
              h="auto"
              minW="0"
              px="0"
              fontSize="13px"
              fontWeight="normal"
              color="gray.500"
              _hover={{ color: 'gray.700' }}
              onClick={() => setIsTosOpen(true)}
              data-testid="footer-terms"
            >
              {t('hatsuly.footer.terms')}
            </Button>
          )}
          <Link
            href={GENERAL_CONTACT_URL}
            target="_blank"
            rel="noopener noreferrer"
            fontSize="13px"
            color="gray.500"
            textDecoration="none"
            _hover={{ color: 'gray.700' }}
            data-testid="footer-contact"
          >
            {t('hatsuly.footer.contact')}
          </Link>
        </HStack>
      </Flex>

      {isTosOpen && (
        <TermsOfServiceModal url={featureFlags!.selfManagedSubscriptions.tos_url} onClose={() => setIsTosOpen(false)} />
      )}
    </Box>
  )
}

export default Footer
